import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Suivi from './pages/Suivi';
import Clients from './pages/Clients';
import MiseAJour from './pages/MiseAJour';
import ChecklistBilan from './pages/ChecklistBilan';
import Facturation from './pages/Facturation';
import Rappels from './pages/Rappels';
import Parametres from './pages/Parametres';
import './App.css';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500">Chargement...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/suivi" replace />;
  }

  return <Layout>{children}</Layout>;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500">Chargement...</div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/suivi" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/suivi"
        element={
          <ProtectedRoute>
            <Suivi />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <ProtectedRoute>
            <Clients />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mise-a-jour"
        element={
          <ProtectedRoute>
            <MiseAJour />
          </ProtectedRoute>
        }
      />
      <Route
        path="/checklist-bilan"
        element={
          <ProtectedRoute>
            <ChecklistBilan />
          </ProtectedRoute>
        }
      />
      <Route
        path="/facturation"
        element={
          <ProtectedRoute>
            <Facturation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rappels"
        element={
          <ProtectedRoute>
            <Rappels />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parametres"
        element={
          <ProtectedRoute adminOnly>
            <Parametres />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/suivi" replace />} />
      <Route path="*" element={<Navigate to="/suivi" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
